export enum CampaignType {
    REVIEW_BOOSTER = 'review_booster',
    PROMOTION = 'promotion',
}

export const MAX_CLIENTS_PER_CAMPAIGN = 10000;
